import { useDispatch } from "react-redux";
import { BulkX2yResponse, X2yResponse } from "../../../requests/x2y/types";
import * as TC from "../thunkCreators";
import { X2yController } from "../types";

const { isArray } = Array;
type Payload = X2yResponse;

const createUseUpdateX2yCallback = (controller: X2yController) => {
  const thunkCreator = TC.createUpdateThunk({ controller });
  const bulkThunkCreator = TC.createBulkUpdateThunk({ controller });

  return () => {
    const dispatch = useDispatch();

    // function callback(xId: number, payload: Payload): Promise<void>;
    // function callback(xIds: number[], payload: Payload): Promise<void>;
    function callback(xIdOrIds: number | number[], payload: Payload) {
      return Promise.resolve().then(() => {
        // Nechci testovat pro arr.length === 1, protože by to imo mátlo v redux dev tools,
        // chci dispatchovat bulk akci pro bulk operace, i když jsem vybral jenom 1 možnost
        const singleIdMode = !isArray(xIdOrIds);

        if (singleIdMode) {
          const xId = xIdOrIds as number;
          dispatch(thunkCreator({ xId, payload }));
          return;
        }

        const xIds = xIdOrIds as number[];
        const x2ys = xIds.reduce((acc, curr) => {
          acc[curr] = payload;
          return acc;
        }, {} as BulkX2yResponse);

        dispatch(bulkThunkCreator({ xIds, payload: x2ys }));
      });
    }

    return callback;
  };
};

export default createUseUpdateX2yCallback;
